import {FACEBOOK_URL} from '@cohort/shared/apps/facebook/common';
import type {FacebookTagInPostTriggerStruct} from '@cohort/shared/apps/facebook/triggers/tagInPost';
import type {ActionCtaComponentProps} from '@cohort/wallet/apps/TriggerIntegration';
import OpenCtaUnverified from '@cohort/wallet/components/challenges/OpenCtaUnverified';
import React from 'react';
import {useTranslation} from 'react-i18next';

const FacebookTagInPostTriggerActionCtaComponent: React.FC<
  ActionCtaComponentProps<FacebookTagInPostTriggerStruct>
> = ({config, processStepVerification, trackingMetadata}) => {
  const {t} = useTranslation('app-facebook', {
    keyPrefix: 'triggerIntegrations.tag-in-post',
  });

  const url = FACEBOOK_URL;

  return (
    <OpenCtaUnverified
      url={url}
      ctaTitle={t('ctaTitle')}
      processStepVerification={processStepVerification}
      trackingMetadata={trackingMetadata}
    />
  );
};

export default FacebookTagInPostTriggerActionCtaComponent;
